import { useContext, useEffect } from "react";
import authContext from "../contexts/auth/authContext";

const Logout = () => {
    const auth = useContext(authContext);
    useEffect(() => {
        auth.logout();
    }, []);

    return null;
};

export default Logout;
